import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        epochBeginning: "",
        api: '',
        apiText: '',
        // walletnxt: 'http://localhost:3003/',
        // iframe: 'http://localhost:8081/',
        http:'',
        walletnxt: '',
        iframe: 'https://block.hebeblock.com/',
        lang: 'en-US',
    },
    mutations: {
        ['getLang'](state) {
            if (localStorage.getItem('lang') != null) {
                state.lang = localStorage.getItem('lang');
            }
        },
        ['setLang'](state, txt) {
            state.lang = txt;
            localStorage.setItem('lang', txt);
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js